import { Typography } from '@mui/material';
import React, { useCallback, useState } from 'react';
import { FC, memo } from 'react';
import { localized } from 'shared/state/i18n/i18n';
import { FlexColumn } from '../basic-flex/flex-column';
import { FlexRow } from '../basic-flex/flex-row';
import './create-site.scss';
import { ProcessEquipmentForm } from './process-equipment-form';
import { SiteOwnerInformation } from './site-owner-information';
import { SiteInformation } from './site-information';
import { SkioldButton } from '../skiold-components/skiold-button/skiold-button';
import { SkioldModal } from '../skiold-components/skiold-modal/skiold-modal';
import { EquipmentList } from './equipment-list';
import { CreateSiteButtons } from './create-site-buttons';
import { useEditContext } from './create-site-context-provider';

interface Props {}

export const CreateSiteForm: FC<Props> = memo(() => {
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const { editingSiteId, stopEditingProcessEquipment } = useEditContext();

	const onAddProcessEquipment = useCallback(() => {
		stopEditingProcessEquipment();
		setIsOpen(true);
	}, [stopEditingProcessEquipment]);

	const openProcessEquipment = useCallback(() => {
		setIsOpen(true);
	}, []);

	const closeProcessEquipment = useCallback(() => {
		setIsOpen(false);
	}, []);

	return (
		<FlexColumn className="createFormContainer">
			<Typography className="create-site-title" fontSize={'24px'}>
				{editingSiteId ? localized('EditFarm') : localized('CreateFarm')}
			</Typography>
			<FlexRow className="form-body">
				<FlexColumn className="column">
					<FlexColumn className="form-section-bordered">
						<SiteOwnerInformation />
					</FlexColumn>
				</FlexColumn>
				<FlexColumn className="column">
					<FlexColumn className="form-section-bordered">
						<SiteInformation />
					</FlexColumn>
					<FlexColumn className="equipment-section">
						<FlexRow className="equipment-header">
							<Typography>{localized('processEquipment')}</Typography>
							<SkioldButton title={localized('Add')} onPress={onAddProcessEquipment} />
						</FlexRow>
						<FlexColumn className="equipment-list-container">
							<EquipmentList openEquipmentForm={openProcessEquipment} />
						</FlexColumn>
					</FlexColumn>
				</FlexColumn>
			</FlexRow>

			<CreateSiteButtons />

			<SkioldModal isOpen={isOpen}>
				<ProcessEquipmentForm onCancel={closeProcessEquipment} />
			</SkioldModal>
		</FlexColumn>
	);
});
